import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

// Actions
import { businessOfficersActions } from '../_actions'

// Components
import Field from './FieldNew'
import { Button } from './Button'
import { ControlsButton } from './ControlsButton'

// Styled Components
const StyledBusinessOfficers = styled.div`
  display: flex;
  flex-direction: column;

  .business-officer {
    display: flex;
    flex-direction: column;
  }
  .business-officer + .business-officer {
    margin-top: 25px;
  }
  .fill-btn {
    width: 50%;
    margin-bottom: 2em;
  }
  .another-btn {
    width: 50%;
    margin-top: 2em;
  }
`

class BusinessOfficers extends React.Component {
  state = {
    shouldUndo: false,
    undoTo: {
      email: '',
      phone: '',
      firstName: '',
      lastName: '',
    },
  }

  changeAndUpdate = (fieldName, val) => {
    const { handleChange, handleBlur, data } = this.props
    handleChange(`business_officers[0].${fieldName}`, val)
    handleBlur(`business_officers[0].${fieldName}`, fieldName, val, data[0].ordinal)
  }

  fillAndUndo = () => {
    const { values, user } = this.props

    if (!this.state.shouldUndo) {
      this.setState({
        undoTo: {
          email: values.business_officers[0].email_address,
          firstName: values.business_officers[0].first_name,
          lastName: values.business_officers[0].last_name,
          phone: values.business_officers[0].phone_number,
          title: values.business_officers[0].title,
        },
      })
    }

    this.changeAndUpdate(
      'phone_number',
      this.state.shouldUndo ? this.state.undoTo.phone : values.business.business_phone_number
    )
    this.changeAndUpdate('email_address', this.state.shouldUndo ? this.state.undoTo.email : user.email_address)

    if (user.first_name)
      this.changeAndUpdate('first_name', this.state.shouldUndo ? this.state.undoTo.firstName : user.first_name)
    if (user.last_name)
      this.changeAndUpdate('last_name', this.state.shouldUndo ? this.state.undoTo.lastName : user.last_name)
    if (user.title) this.changeAndUpdate('title', this.state.shouldUndo ? this.state.undoTo.title : user.title)

    this.setState((prev) => ({ shouldUndo: !prev.shouldUndo }))
  }

  render() {
    const {
      data,
      fields,
      label,
      values,
      handleBlur,
      handleChange,
      user,
      errors,
      touched,
      businessId,
      createBusinessOfficer,
      deleteBusinessOfficer,
      fieldStateUpdate,
      overrideShowError,
      setValues,
    } = this.props

    return (
      <StyledBusinessOfficers className={`business-officers`}>
        {data.length === 0 ? (
          <p>You do not have any {label}s set up.</p>
        ) : (
          [
            <div className={`fill-btn`} key={-1}>
              <Button
                buttonType={`button`}
                key={`BusinessOfficers FillFromContact`}
                onClick={this.fillAndUndo}
                text={
                  this.state.shouldUndo
                    ? `Undo Fill`
                    : this.props.fill_btn
                      ? this.props.fill_btn
                      : `Fill ${label} 1 From Contact`
                }
                type={`button`}
              />
            </div>,
            data.map((businessOfficer, i) => (
              <div className={`business-officer`} key={i}>
                <h4>
                  {label} {i + 1}
                  <ControlsButton
                    handleClick={() => {
                      deleteBusinessOfficer(businessOfficer.id)
                      setValues({
                        ...values,
                        business_officers: data.filter((bo) => {
                          return bo.id != businessOfficer.id
                        }),
                      })
                    }}
                    icon={'delete'}
                    isDisabled={i === 0 ? true : false}
                  />
                </h4>
                {fields.map((field, ii) => {
                  const isDocument = field?.type?.includes('upload_document')
                  return (
                    <Field
                      errors={errors}
                      field={{
                        ...field,
                        name: isDocument ? `bo_${i + 1}_${field.name}` : field.name,
                        required: field.required,
                      }}
                      fieldStateUpdate={fieldStateUpdate}
                      handleBlur={(name, attr, val, table, invalid) => {
                        handleBlur(name, attr, val, businessOfficer.ordinal, isDocument, invalid)
                      }}
                      handleChange={handleChange}
                      index={i}
                      key={ii}
                      overrideShowError={overrideShowError}
                      touched={touched}
                      values={values}
                    />
                  )
                })}
              </div>
            )),
          ]
        )}
        {data.length < 5 && (
          <div className={`another-btn`}>
            <Button
              buttonType={`button`}
              onClick={() => createBusinessOfficer(businessId)}
              text={`Add ${data.length > 0 ? `Another ` : ``}${label}`}
              type={`button`}
            />
          </div>
        )}
      </StyledBusinessOfficers>
    )
  }
}

function mapStateToProps(state) {
  const { business } = state
  return {
    businessId: business.id,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    createBusinessOfficer: (businessId) => {
      dispatch(businessOfficersActions.createBusinessOfficer(businessId))
    },
    deleteBusinessOfficer: (businessOfficerId) => {
      dispatch(businessOfficersActions.deleteBusinessOfficer(businessOfficerId))
    },
  }
}

const connectedBusinessOfficers = connect(mapStateToProps, mapDispatchToProps)(BusinessOfficers)
export { connectedBusinessOfficers as BusinessOfficers }
